import { normalizeBoolean } from '@change/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_MEMBERSHIP_BOTTOM_BANNER_ENABLED_FOR = createFcmConfig('membership_bottom_banner_enabled_for', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
